<template>
<div>
	<v-menu
		v-model="menu"
		:close-on-content-click="false"
		transition="scale-transition"
		offset-y
		bottom
		:nudge-bottom="8"
		:nudge-left="40"
		class="background darken-1"
		full-width
		min-width="290px">

		<template v-slot:activator="{ on }">
			<v-text-field
				:value="value"
				:class="dense ? 'grv-input-dense' : 'grv-input'"
				@change="$emit('update:value', $event)"
				append-icon="event"
				:name="param.name"
				style="width: 290px"
				readonly
				:rules="rules"
				v-on="on">
				<template v-slot:label>
					<Label :param="param"></Label>
				</template>
			</v-text-field>
		</template>

		<v-date-picker
			:value="value"
			@input="menu = false; $emit('update:value', $event)"
			color="primary color--text"
			class="background darken-1"
			locale="fr-fr"
			reactive
			:readonly="readonly"
			:first-day-of-week="1">
		</v-date-picker>
	</v-menu>

	<Hint :param="param"></Hint>
</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			menu: false
		}
	},
	methods: {
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
	}
}
</script>

<style lang="stylus" scoped>
>>>.v-picker__body
	background: transparent !important
</style>



// WEBPACK FOOTER //
// src/components/fields/date.vue